import { defaultModalProps, deleteBrokerModalSuccessProps } from 'modal-tpyes'
import {
  useMediaQuery,
  useTheme,
  Dialog,
  makeStyles,
  Typography,
  Button,
  Grid,
  Box,
} from '@material-ui/core'
import React , { useState, useEffect} from 'react'
import {useHistory} from 'react-router-dom'
interface stylesProp {
  useMobileUI:boolean
}

const useStyles = makeStyles((theme)=>({
  root: (props:stylesProp) => ({
    borderRadius: theme.spacing(1) ,
    backgroundColor: "white",
    margin:"0px",
    minWidth: props.useMobileUI? "0":"100%",
    padding: theme.spacing(3),
  }),
  closeIcon : {
    position: "absolute",
    color: theme.palette.primary.main,
    top: theme.spacing(2),
    left: theme.spacing(3),
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  container : {
    padding:32,
  },
  textBlack: {
    color: "#000"
  },
  confirmSvg: {
    fill: theme.palette.primary.main,
    justifyItems:"center"
  },
}))


const DeleteBrokerSuccessModal:React.FC<defaultModalProps> = ({
  open,
  // handleBack,
  handleClose,
  props:modalProps,
}) => {

  const theme = useTheme();
  const useMobileUI = useMediaQuery(theme.breakpoints.up("sm"));
  const styleProps = { useMobileUI: useMobileUI };
  const classes = useStyles(styleProps);
  const [props,setProps] = useState<deleteBrokerModalSuccessProps>()
  const history = useHistory();
  const [timeLeft, setTimeLeft] = useState(0);

  useEffect(() => {
    if (open) setTimeLeft(5);
  }, [open]);
  
  useEffect(() => {
    const timer = setTimeout(() => {
      if (timeLeft >= 1) {
        setTimeLeft((timeleft) => timeleft - 1);
      }
      if (timeLeft === 1) {
        onClose();
      }
    }, 1000);
    return () => clearTimeout(timer);
  });

  const onClose = () => {
    handleClose()
    history.go(0)
  }

  const ModalProps = {
    paper: classes.root,
  };


  useEffect(()=>{
    if (modalProps) {
      setProps(modalProps)
    }
  },[modalProps])

  //JSX Varialbes ...
  const renderDeleteSuccess = (
    <Box>
      <Box px={5} py={2} justifyContent="center" display="flex" flexDirection="column" alignItems="center">
        <svg
          width="84"
          height="84"
          viewBox="0 0 84 84"
          xmlns="http://www.w3.org/2000/svg"
          className={classes.confirmSvg}
        >
          <path d="M61.1252 23.583L33.6668 51.0413L18.7085 36.1247L12.8335 41.9997L33.6668 62.833L67.0002 29.4997L61.1252 23.583ZM42.0002 0.333008C19.0002 0.333008 0.333496 18.9997 0.333496 41.9997C0.333496 64.9997 19.0002 83.6664 42.0002 83.6664C65.0002 83.6664 83.6668 64.9997 83.6668 41.9997C83.6668 18.9997 65.0002 0.333008 42.0002 0.333008ZM42.0002 75.333C23.5835 75.333 8.66683 60.4163 8.66683 41.9997C8.66683 23.583 23.5835 8.66634 42.0002 8.66634C60.4168 8.66634 75.3335 23.583 75.3335 41.9997C75.3335 60.4163 60.4168 75.333 42.0002 75.333Z" />
        </svg>
        <Box pt={3}>
          <Typography color="textSecondary" align="center">{`ยกเลิกการผู้บัญชี ${props?.brokerName} สำเร็จ`}</Typography>
        </Box>
        <Box py={1}>
          <Typography color="textSecondary" align="center">{`หมายเลขบัญชีหุ้นของ ${props?.username}`}</Typography>
          {/* {props?.accountNos?.map((accountNo)=>(
            <Box key={accountNo.accountNo}>
              <Typography color="textSecondary" align="center">{'- ' + accountNo.accountNo}</Typography>
            </Box>
          ))} */}
          <Typography color="textSecondary" align="center">{`ถูกลบสำเร็จ`}</Typography>
        </Box>
      </Box>
    </Box>
  )

  const renderDeleteFail = (
    <Box>
    <Box px={5} py={2} justifyContent="center" display="flex" flexDirection="column" alignItems="center">
      <svg
        width="84"
        height="84"
        viewBox="0 0 84 84"
        xmlns="http://www.w3.org/2000/svg"
        className={classes.confirmSvg}
      >
        <path d="M61.1252 23.583L33.6668 51.0413L18.7085 36.1247L12.8335 41.9997L33.6668 62.833L67.0002 29.4997L61.1252 23.583ZM42.0002 0.333008C19.0002 0.333008 0.333496 18.9997 0.333496 41.9997C0.333496 64.9997 19.0002 83.6664 42.0002 83.6664C65.0002 83.6664 83.6668 64.9997 83.6668 41.9997C83.6668 18.9997 65.0002 0.333008 42.0002 0.333008ZM42.0002 75.333C23.5835 75.333 8.66683 60.4163 8.66683 41.9997C8.66683 23.583 23.5835 8.66634 42.0002 8.66634C60.4168 8.66634 75.3335 23.583 75.3335 41.9997C75.3335 60.4163 60.4168 75.333 42.0002 75.333Z" />
      </svg>
      <Box py={3}>
        <Typography color="textSecondary" align="center">{`ลบบัญชี ${props?.username} สำเร็จ`}</Typography>
      </Box>
    </Box>
  </Box>
  )

  const renderTimerButton = (
    <Grid container justifyContent="space-around">
      <Button color="primary" variant="contained" onClick={onClose}>
        <Typography variant="subtitle1"><Typography color="textPrimary">
          {`กลับไปหน้าเดิมใน ${timeLeft} วินาที`}  
        </Typography></Typography>
      </Button>
    </Grid>
  )

  return (
    <Dialog open={open||false}  keepMounted onClose={onClose} classes={ModalProps} maxWidth="xl">
      {props?.isSuccess ? renderDeleteSuccess : renderDeleteFail}
      {renderTimerButton}
    </Dialog>
  )
}

export default DeleteBrokerSuccessModal